/** SB-612: Register delegated heading navigation and nearest-layer Escape once.
 * Loess owns click, Enter/Space, open state and ARIA synchronization.
 * Preserve heading navigation and nearest-layer Escape without retoggling on
 * Enter/Space. Delegation covers filter/cart HTML replaced after AJAX.
 */
(() => {
  'use strict';
  if (window.sbAccordionKeyboard) return;
  window.sbAccordionKeyboard = true;
  document.addEventListener('keydown', event => {
    if (event.defaultPrevented || !(event.target instanceof Element)) return;
    const selector = 'loess-collapsible-panel[open]:not([dismissable]):not([overlay]):not([role="dialog"]), loess-drawer#SideBarMenu[open], loess-drawer[id^="SidebarMenu-"][open], loess-filters[open]';
    const trigger = event.target.closest('button[is="loess-button"][aria-controls]');
    const controlled = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
    if (['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key) && controlled?.matches('loess-collapsible-panel:not([dismissable]):not([overlay]):not([role="dialog"])')) {
      const groups = '.drawer-menu, .sidebar-menu, .collection-filters, .filters, .collapsible-content-list, .main-product__blocks';
      const group = trigger.closest(groups);
      if (!group) return;
      const headings = Array.from(group.querySelectorAll('button[is="loess-button"][aria-controls]')).filter(button =>
        button.closest(groups) === group && !button.disabled && button.getClientRects().length &&
        !button.closest('[hidden], [inert]') && getComputedStyle(button).visibility !== 'hidden' &&
        document.getElementById(button.getAttribute('aria-controls'))?.matches('loess-collapsible-panel:not([dismissable]):not([overlay]):not([role="dialog"])'));
      const index = headings.indexOf(trigger);
      if (index < 0) return;
      let next = event.key === 'ArrowUp' ? (index - 1 + headings.length) % headings.length : (index + 1) % headings.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = headings.length - 1;
      event.preventDefault();
      headings[next].focus();
      return;
    }
    if (event.key !== 'Escape') return;
    const panel = controlled?.matches(selector) ? controlled : event.target.closest(selector);
    if (!panel) return;
    const opener = Array.from(document.querySelectorAll('button[is="loess-button"][aria-controls]'))
      .find(button => button.getAttribute('aria-controls') === panel.id);
    event.preventDefault();
    // Handle the inner disclosure before an enclosing drawer's Escape trap.
    event.stopImmediatePropagation();
    panel.open = false;
    const checkout = panel.id === 'CartNotesPanel' && panel.contains(event.target) &&
      panel.closest('loess-drawer')?.querySelector('button[name="checkout"]:not([disabled])');
    if (checkout) checkout.focus();
    else if (opener) opener.focus();
  }, true);
})();
